export default {
  selectedTab: '1',
  versionProps: {
    title: '柱状图',
    widgetNum: '2',// 每种组件的唯一编码
    version: '1',  // 每种组件的版本号
    upgrade: true,
    docUrl: '/datavisual/doc/widget'
  },
  viewProps: {
    width: '300',
    height: '300',
    top: 0,
    left: 0,
    chartOption: {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: 'Direct',
          type: 'bar',
          barWidth: '60%',
          data: []
        }
      ]
    }
  },
  datasourceProps: {
    datasourceType: 'STATIC', // STATIC/API
    dataMapping:
    [
      {id: 1, prop:'xAxis', label: "X坐标", field: 'date'},
      {id: 2, prop:'series', label: "Y值", field: 'value'},
    ],
    // dataSourceType = STATIC的静态数据/API的返回数据
    // [{date: '202404', value: 12},{date: '202405', value: 18},]
    // 转换后：
    // xAxisData=['202404', '202405']
    // xSeriesData=[12, 18]
    // 需要设置到
    // chartOption.series.data=xSeriesData
    // chartOption.xAxis.data=xAxisData
    dataConfig: {
      'STATIC': {
        data: [
          {date: '202401', value: 12},
          {date: '202402', value: 120},
          {date: '202403', value: 150},
          {date: '202404', value: 100},
          {date: '202405', value: 119},
          {date: '202406', value: 78},
          {date: '202407', value: 96},
          {date: '202408', value: 48},
          {date: '202409', value: 105},
        ]
      },
      'API': {
        datasource: null,         // datasourceType = API
        datasourceLabel: null,    // datasourceType = API
        reqParams: null,          // datasourceType = API时候的请求参数
        data: [],
      },
    }
  }
}
